/**
 * Device preferences. Logout keeps these and clears every other key, so a key that holds anything
 * about the user must not be listed here.
 */
export const COLOUR_THEME_STORAGE_KEY = 'fletch_colour_theme';
export const SIDEBAR_MODE_STORAGE_KEY = 'fletch:sidebar-mode';
export const TEXT_PREFERENCES_STORAGE_KEY = 'fletch:text-preferences';
export const CREATE_CASE_IMPORT_INFO_STORAGE_KEY = 'create-case:import-info:dismissed';

export const DEVICE_PREFERENCE_STORAGE_KEYS: readonly string[] = [
  COLOUR_THEME_STORAGE_KEY,
  SIDEBAR_MODE_STORAGE_KEY,
  TEXT_PREFERENCES_STORAGE_KEY,
  CREATE_CASE_IMPORT_INFO_STORAGE_KEY,
];
